import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { InvoiceDetailContent } from 'modules/finance/components/Invoices/Detail/Content'
import { Header } from 'modules/finance/components/Invoices/Detail/Header'
import { InvoiceViewerLayout } from 'modules/finance/components/Invoices/Detail/InvoiceViewerLayout'
import { useInvoiceDetail } from 'modules/finance/hooks/useInvoiceDetail'
import { isInvoiceDeletable } from 'modules/finance/lib/invoices'

interface Props {
  invoiceId: number
  onClose: () => void
}

const InvoiceDetail = ({ invoiceId, onClose }: Props) => {
  const { company } = useCurrentSession()
  const {
    invoice,
    file,
    legalEntities,
    taxTypes,
    canManageJournalEntries,
    reconciliationsSeeJournalEntriesPage,
    reconciliationsSeeFinancialDocumentsPage,
    journalLines,
  } = useInvoiceDetail({ invoiceId, companyId: company.id })

  if (!invoice || !file) return null

  return (
    <InvoiceViewerLayout
      onClose={onClose}
      filename={String(file.filename)}
      contentType={String(file.contentType)}
      url={String(file.url)}
      isUrlAbsolute
      content={
        <Box aria-label="invoiceSidepanel" overflowY="auto" style={{ height: '100vh' }}>
          <Box position="relative">
            <Header onClose={onClose} canDelete={isInvoiceDeletable(invoice)} />
          </Box>
          <InvoiceDetailContent
            invoice={invoice}
            legalEntities={legalEntities}
            onClose={onClose}
            taxTypes={taxTypes}
            canManageJournalEntries={canManageJournalEntries}
            canReconcileWithJournalLines={reconciliationsSeeJournalEntriesPage}
            canReconcileWithFinancialDocuments={reconciliationsSeeFinancialDocumentsPage}
            journalLines={journalLines}
          />
        </Box>
      }
    />
  )
}

export default InvoiceDetail
